<template>
  <div class="page page__list">
    <search-bar @search="onSearch" name="pr_detail,wh_description,pi_vendname,pr_orispeccode,pr_code,ba_code" placeholder="输入物料、仓库、客户、供应商进行查找" ref="searchBar" />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.ba_code}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.ba_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted">{{item.pr_code}}</p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}批</label>
      <!-- <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/report/batchDetail",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 99999,
        calculateFields: JSON.stringify([
          {"field":"ba_remain","operation":"sum"},
          {"field":"ba_inqty","operation":"sum"},
          {"field":"ba_outqty","operation":"sum"},
          {"field":"ba_zyqty","operation":"sum"}
        ]),
        page: 1,
        start: 0,
        limit: 99999
      },
      filters: [
        {
          type: "date",
          name: "ba_date"
        }
      ],
    };
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "StockBatchdetailReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    }
  },
};
</script>